module.exports = __webpack_public_path__ + "img/post_2.4532ed48.jpg";